// extracted by mini-css-extract-plugin
export default {"cls1":"W1cAPTXIxF6BGgof_7Iy","cls2":"_IzU6Exd0cNmwf0E3re_ W1cAPTXIxF6BGgof_7Iy"};